import { Container, Grid, Button, Box, Alert, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useState } from "react";
import { useSelector } from "react-redux";
import BlacklistedSecuritiesSkeleton from "../../../../../../component/spinner/BlacklistedSecuritiesSkeleton";
import {selectActiveRequests } from "../../../../../../Redux/Reducers/selectors";

const SwapStep1 = ({ setCurrentStep, contracts }) => {
  const [selectedContract, setSelectedContract] = useState(null);
  const [blacklist, setBlacklist] = useState([]);
  const activeRequests = useSelector(selectActiveRequests);
  const onNext = () => {
    setCurrentStep((prev) => prev + 1);
  };
   const isLoadingBlacklistedData = activeRequests.includes("rebalancer_check_blacklist");

   // Show skeleton while loading
   if (isLoadingBlacklistedData) {
     return <BlacklistedSecuritiesSkeleton />;
   }

  return (
    <Container disableGutters maxWidth="100%" sx={{ marginTop: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box sx={{ width: "40%" }}>
              <Box
                sx={{
                  marginBottom: 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
                  Blacklisted Contracts
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <select
                    value={selectedContract || "all"}
                    onChange={(e) => setSelectedContract(e.target.value)}
                    style={{
                      padding: "5px",
                      fontSize: "14px",
                      marginBottom: 10,
                    }}
                    size="small"
                  >
                    <option value="all">All</option>
                    {contracts?.map((contract) => (
                      <option key={contract.type} value={contract.type}>
                        {contract.name}
                      </option>
                    ))}
                  </select>
                </Box>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                onClick={onNext}
                sx={{ width: "150px", height: "40px" }}
              >
                Next
              </Button>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ display: "flex", flexDirection: "column", width: "40%" }}>
            <Alert severity="info">
              The securities that appear below will not be counted in final
              rebalancer contracts.
            </Alert>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ display: "flex", flexDirection: "row", width: "40%" }}>
            {blacklist?.length > 0 ? (
              <></>
            ) : (
              <Typography>No data available</Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SwapStep1;
